import { useQuery, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import { isLogoutInProgress } from "../../../session/logoutState";

function useSignature() {
  const { authState } = useOktaAuth();
  const profile: any = useQueryClient()?.getQueryData(["profile"]);
  return useQuery({
    queryKey: ["physicianSignature"],
    retry: false,
    refetchOnWindowFocus: false,
    queryFn: () =>
      axiosInstance
        .get("v1/esignature/my-esignature", {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        .then((res) => res.data),
    enabled:
      !!authState?.accessToken?.accessToken &&
      !isLogoutInProgress() &&
      !!profile &&
      profile?.user?.roles?.includes?.("Physician"),
  });
}

export default useSignature;
